import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@womcorp/wom-miwom-ui-kit/dist/components/Button';
import { NoPaymentsIcon as NotFoundIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import {
  Container,
  PanelTitle,
  ChildrenContainer,
} from './styles/NotFoundStyled';
import { GoogleTagManager } from '../../helpers';

const NotFoundPanel = ({
  markOptions,
  title,
  children,
  onClick,
  buttonText,
}) => {
  useEffect(() => {
    if (
      markOptions &&
      Object.values(markOptions).every(value => value !== '')
    ) {
      GoogleTagManager.pushToDataLayer(markOptions);
    }
  }, []);

  return (
    <Container>
      <NotFoundIcon />
      <PanelTitle>{title}</PanelTitle>
      <ChildrenContainer>{children}</ChildrenContainer>
      <Button color="corporate" variant="outlined" onClick={onClick}>
        {buttonText}
      </Button>
    </Container>
  );
};
const markPropsShape = PropTypes.shape({
  event: PropTypes.string,
  page: PropTypes.string,
  pagename: PropTypes.string,
});

NotFoundPanel.defaultProps = {
  markOptions: {
    event: '',
    page: '',
    pagename: '',
  },
};

NotFoundPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  markOptions: markPropsShape,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NotFoundPanel;
